export const HELP_CENTER_URL = 'https://www.siteup.com.br/ajuda';

const FEATURE_HELP_URLS = {
  agent_bots: `${HELP_CENTER_URL}/capitao/configurar-agent-bots`,
  agents: `${HELP_CENTER_URL}/primeiros-passos/convidar-atendentes`,
  audit_logs: `${HELP_CENTER_URL}/primeiros-passos/navegar-configuracoes-administrativas`,
  campaigns: `${HELP_CENTER_URL}/agendamentos-campanhas/campanhas-broadcast`,
  canned_responses: `${HELP_CENTER_URL}/automacoes/macros-workflows-1clique`,
  channel_email: `${HELP_CENTER_URL}/canais/conectar-email`,
  channel_facebook: `${HELP_CENTER_URL}/canais/facebook-messenger`,
  custom_attributes: `${HELP_CENTER_URL}/contatos/atributos-customizados`,
  dashboard_apps: `${HELP_CENTER_URL}/integracoes-api/usar-dashboard-apps-conversa`,
  help_center: HELP_CENTER_URL,
  inboxes: `${HELP_CENTER_URL}/canais/configurar-caixas-canais`,
  integrations: `${HELP_CENTER_URL}/integracoes-api/visao-geral`,
  labels: `${HELP_CENTER_URL}/primeiros-passos/usar-etiquetas-campos-personalizados`,
  macros: `${HELP_CENTER_URL}/automacoes/macros-workflows-1clique`,
  reports: `${HELP_CENTER_URL}/relatorios/visao-geral`,
  sla: `${HELP_CENTER_URL}/equipe-permissoes/sla-horarios-comerciais`,
  team_management: `${HELP_CENTER_URL}/equipe-permissoes/gerenciar-usuarios-times-permissoes`,
  webhook: `${HELP_CENTER_URL}/integracoes-api/webhooks-customizados`,
  billing: `${HELP_CENTER_URL}/conta-faturamento/plano-e-limites`,
  saml: `${HELP_CENTER_URL}/equipe-permissoes/sso-saml`,
  captain_billing: `${HELP_CENTER_URL}/conta-faturamento/plano-e-limites`,
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
